import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31f8c748&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=31f8c748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8c748",
  null
  
)

export default component.exports